import { inject } from "@angular/core";
import { CanMatchFn, Route, Router, UrlSegment } from "@angular/router";
import { AuthService } from "@core/services/auth/auth.service";
import { AuthAsaasService } from "@core/services/auth/auth-asaas.service";
import { firstValueFrom } from "rxjs";
import { AsaasService } from "@core/services/auth/asaas.service";

export const loggedInAuthGuardFn: CanMatchFn = async (
	_: Route,
	segments: UrlSegment[]
) => {
	const authService = inject(AuthService);
	const router = inject(Router);
	const authAsaasService = inject(AuthAsaasService);
	const asaasService = inject(AsaasService);
	const url = segments.map((s) => s.path).join("/");
	const code = new URL(window.location.href).searchParams.get("code") ?? null;

	if (url.includes("/auth/asaas") && code == null) {
		await firstValueFrom(asaasService.logout());
		await firstValueFrom(asaasService.logoutLegacy());
		return true;
	}

	if (authAsaasService.isLoginAsaasByUrl()) {
		await firstValueFrom(authAsaasService.forceLoginByGuard());
	}

	if (authService.getTokenSupportAccountant()) {
		if (authService.isSupportLoggedInAsNormalUser()) {
			authService.removeUserToken();
			authService.removeSupportLoggedInAsNormalUser();
		}
		return router.parseUrl("/suporte");
	}

	if (authService.isLoggedOut() && !authService.getTokenSupportAccountant()) {
		return true;
	}

	return router.parseUrl("/home");
};
